class UserModalController {

    constructor(
        UserHelper,
        UserModalService
    ) {
        'ngInject'

        this.UserHelper = UserHelper;
        this.UserModalService = UserModalService;

    }

    $onInit() {
        this.user = this.resolve.user;
        this.clientList = this.resolve.clientList;
        this.customPermissionsIds = this.UserHelper.getCustomPermissions(this.user).map((p) => p.id);
        this.itemsPerPage = 5;

        this.canViewAllClients = this.UserHelper.hasPermission(this.user, this.UserHelper.viewAllClientsCode, true);
        this.canViewAllPhysicalTherapyClients = this.UserHelper.hasPermission(this.user,
                                                                              this.UserHelper.viewPTClientsCode,
                                                                              true);
        this.clientIds = angular.copy(this.user.client_ids);
    }

    addClient(client) {
        if (this.clientIds.indexOf(client.id) === -1) {
            this.user.clients.push(client);
            this.clientIds.push(client.id);
        }
    }

    closeModal() {
        this.modalInstance.close();
    }

    saveModal() {
        const permissions = {
            VIEW_ALL_CLIENTS: this.canViewAllClients,
            VIEW_PT_CLIENTS: this.canViewAllPhysicalTherapyClients
        };

        const clientPermissions = this.UserHelper.getConditionalPermissionIds(permissions);
        const customPermissions = this.customPermissionsIds.concat(clientPermissions);

        this.UserModalService.updateUser(this.user.id,
                                         this.clientIds,
                                         customPermissions)
            .then((successResponse) => {
                this.modalInstance.close()
            })
    }

    toggleClient(client) {
        const clientIdIndex = this.clientIds.indexOf(client.id);
        if (clientIdIndex > -1) {
            client.isRemoved = true;
            this.clientIds.splice(clientIdIndex, 1);
        }
        else {
            this.clientIds.push(client.id);
            client.isRemoved = false;
        }
    }

    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

}

export default UserModalController;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-modal/user-modal-controller.js